var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3625 37.7625V13.5938H52.7251L65.1188 26.1188V27.8438V37.7625",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7252 13.5938V26.4562H65.119",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4375 70.9873V76.4061H19.5",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4563 41.6631H74.4375V67.8193",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7938 34.0689H74.4376V41.6439H23.4376V72.4502C23.4376 74.6252 21.6751 76.4064 19.4813 76.4064C17.2876 76.4064 15.5438 74.6252 15.5438 72.4502V31.0127H22.7251",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0688 65.9253H54.0938L49.1625 60.994L47.1938 59.0065L40.3313 52.144H44.2688L49.1625 57.0378L51.1501 59.0065L58.0688 65.9253Z",
    fill: "#24293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2375 60.0751L48.1688 62.0251L44.2688 65.9251H40.3313L46.2 60.0376L46.2375 60.0751Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0688 52.144L50.1563 60.0378L48.2063 58.1065L48.1688 58.0878L54.1126 52.144H58.0688Z",
    fill: "#24293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2188 26.4561H45.75",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2188 32.6621H51.2625",
    stroke: "#24293D",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ff6d2fe1a06157e1268dcb88f3d6c642.svg";
export { ForwardRef as ReactComponent };